import * as actionType from "../constants";
export const removeAttachmnt = (idd) => async (dispatch) => {
  try {
    dispatch({ type: actionType.REMOVE_ATTACHMENT, idd: idd });
  } catch (error) {
    console.log(error.message);
  }
};
